"use client";

import { cn } from "@/lib/utils";
import * as React from "react";
import { type DateRange } from "react-day-picker";
import DateRangePickerModal from "../shared/DateRangePickerModal";

interface DateRangePickerProps {
  className?: string;
  dateRange?: DateRange;
  onSelect?: (range: DateRange | undefined) => void;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSelectionComplete?: () => void; // Called when date range is confirmed and modal closes
  availableDates?: string[];
  isAvailabilityPending?: boolean;
  constrainAvailability?: boolean;
}

export default function DateRangePicker({
  className,
  dateRange,
  onSelect,
  disabled = false,
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
  onSelectionComplete,
  availableDates,
  isAvailabilityPending,
  constrainAvailability,
}: DateRangePickerProps) {
  const [internalOpen, setInternalOpen] = React.useState(false);
  
  // Use controlled open if provided, otherwise use internal state
  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = controlledOnOpenChange || setInternalOpen;

  const handleOpenChange = (value: React.SetStateAction<boolean>) => {
    if (disabled) return;
    const newValue = typeof value === "function" ? value(open) : value;
    setOpen(newValue);
  };

  const handleSelect = (range: DateRange | undefined) => {
    if (disabled) return;
    onSelect?.(range);
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <DateRangePickerModal
        open={open && !disabled}
        setOpen={handleOpenChange}
        dateRange={dateRange}
        onSelect={handleSelect}
        disabled={disabled}
        onSelectionComplete={onSelectionComplete}
        availableDates={availableDates}
        isAvailabilityPending={isAvailabilityPending}
        constrainAvailability={constrainAvailability}
      />
    </div>
  );
}
